module.exports = __webpack_public_path__ + "img/logo_sign_in.62ad7b03.png";